module.exports = __webpack_public_path__ + "static/media/regulamento.dddfc881.pdf";